import React, { ReactNode } from 'react'
import { PostCallout } from '../PostCallout'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { ContactItem } from './ContactItem'
import { PostContactCard } from '../../../../generated/api/post-row'

interface PostContactsProps {
  contacts: PostContactCard[]
}

export const PostContacts = ({ contacts }: PostContactsProps): ReactNode => {
  const { translate } = useAppTranslation()

  if (contacts.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      <PostCallout text={translate('post.newContactText')} />
      {contacts.map((contact) => (
        <ContactItem key={contact.id} contact={contact} />
      ))}
    </div>
  )
}
